import React from "react";

export const Table = ({ headers, children }) => (
  <div className="w-full bg-white">
    <div className="overflow-x-auto">
      <table className="w-full text-sm text-left">
        <thead className="border-b border-slate-100">
          <tr>
            {headers.map((h, i) => (
              <th
                key={i}
                className="px-4 py-3 text-[11px] font-bold text-[#C91D25] uppercase tracking-wider"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">{children}</tbody>
      </table>
    </div>
  </div>
);

export const DetailField = ({ label, value, fullWidth = false, className = "" }) => (
  <div
    className={`${
      fullWidth ? "col-span-full" : "col-span-1"
    } flex flex-col justify-center`}
  >
    <div className="text-[12px] text-slate-500 mb-0.5 font-semibold tracking-wider opacity-70">
      {label}
    </div>
    <div className={`text-xs font-semibold text-brand-dark ${className}`}>
      {value || "—"}
    </div>
  </div>
);
